import { LoggingService } from './../../../core/services/logging.service';
import { sortDropdownBydropdownOrder } from 'src/app/shared/utilities/util';
import { CoreService } from './../../../core/services/core.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataCaptureService } from 'src/app/modules/data-capture/services/data-capture.service';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_WARNING,
} from '../../constants/constant';
import { ERROR_OCCURED_TRY_AGAIN_LATER } from '../../constants/messages';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { UserFileDownload } from '../../models/userDetail.model';
import { base64ToArrayBuffer, saveByteArray } from '../../utilities/util';
import { ToasterNotificationService } from '../toaster-notification/toaster-notification.service';
import { Dropdown } from '../../models/dropdown.model';

@Component({
  selector: 'app-import-excel',
  templateUrl: './import-excel.component.html',
  styleUrls: ['./import-excel.component.scss'],
})
export class ImportExcelComponent implements OnInit {
  @Input() workflowID: string;
  @Input() yearCode: string;
  @Input() tabCode: number;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onRefresh: EventEmitter<any> = new EventEmitter();
  fileToUpload: File = null;
  uploadForm: FormGroup;
  files: any = [];
  formSubmitted = false;
  alert: NotificationAlert;
  fileuploaddone: boolean = false;
  public successfulImport = false;
  public alertMessages = [];
  public uploadedFileSize: string;
  public warningalert = {
    type: NOTIFICATION_WARNING,
    message:
      'Please review the data entered in each tab before submitting it for review',
  };

  constructor(
    private dataCaptureService: DataCaptureService,
    private toasterNotificationService: ToasterNotificationService,
    private manageUsersService: ManageUsersService,
    private coreService: CoreService,
    private loggingService: LoggingService
  ) {}

  ngOnInit(): void {
    this.uploadForm = this.manageUsersService.getUsersUploadFormControls();
  }

  public close(): void {
    this.onClose.emit();
  }
  public refresh(): void {
    this.onRefresh.emit();
  }

  public onFileSelect(file): void {
    if (file) {
      this.fileToUpload = file;
    }
  }

  public onUploadFile(event): void {
    this.files = [];
    this.alert = null;

    for (let index = 0; index < event.length; index++) {
      const fileExt = event[index].name.split('.');
      if (
        fileExt[fileExt.length - 1] &&
        (fileExt[fileExt.length - 1].indexOf('xls') > -1 ||
          fileExt[fileExt.length - 1].indexOf('xlsx') > -1)
      ) {
        const element = event[index];
        this.files.push(element);
        this.fileuploaddone = true;

        this.onSubmitPerTab();
      } else {
        let message = 'Please select excel file.';
        if (this.workflowID) {
          message =
            'File has not been imported. Please ensure the file has been downloaded via the Export Excel button.';
        }
        this.alert = {
          type: NOTIFICATION_ERROR,
          message,
        };
      }
    }
  }

  public async onSubmitPerTab(): Promise<void> {
    this.formSubmitted = true;
    this.successfulImport = false;

    if (!this.files || !this.files.length) {
      this.formSubmitted = false;
      this.alert = {
        type: NOTIFICATION_WARNING,
        message: 'Please upload file.',
      };
    }

    const formData = new FormData();
    this.alertMessages = [];
    const alertMessagesArr = [];
    formData.append('file', this.files[0]);

    const tabs = this.coreService
      .getDropdownValuesByID(this.tabCode)
      .sort(sortDropdownBydropdownOrder);

    for (const tab of tabs) {
      const messages = await this.uploadPerTab(formData, tab);

      alertMessagesArr.push(...messages);
    }

    this.formSubmitted = false;
    this.fileuploaddone = true;
    this.alertMessages = alertMessagesArr;
  }

  private async uploadPerTab(formData: FormData, tab: Dropdown) {
    let alertMessagesArr = [];

    try {
      const element = await this.dataCaptureService
        .uploadExcelFile(
          formData,
          this.workflowID,
          this.yearCode,
          tab.dropdownID
        )
        .toPromise();

      if (element.responseCode === 200) {
        alertMessagesArr.push({
          type: NOTIFICATION_SUCCESS,
          message: element.message,
        });
        this.successfulImport = true;
      } else if (element.responseCode === 500) {
        alertMessagesArr.push({
          type: NOTIFICATION_ERROR,
          message: element.message,
        });
      }
    } catch (error) {
      this.formSubmitted = false;
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: 'Something went wrong please try again.',
      };
    }

    return alertMessagesArr;
  }

  public downloadTemplate(): void {
    this.formSubmitted = true;
    this.fileuploaddone = true;
    this.dataCaptureService
      .downloadExcelFile(this.workflowID, this.yearCode, this.tabCode)
      .subscribe(
        (response: UserFileDownload) => {
          if (response) {
            const sampleBytes = base64ToArrayBuffer(response.fileContents);
            saveByteArray([sampleBytes], response.fileDownloadName);
          } else {
            this.toasterNotificationService.showErrorNotification(
              'Unable to download sample template.'
            );
          }
          this.formSubmitted = false;
          this.fileuploaddone = false;
        },
        (error) => {
          this.loggingService.logException(error);
          this.formSubmitted = false;
          this.fileuploaddone = false;
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
          };
        }
      );
  }

  public done(): void {
    this.onRefresh.emit();
  }
}
